import { Logger } from "../../02_utils/logger";
import { PanelService } from "./services/panelService";

export class Panel {
  constructor(private $log: Logger, private $panel: PanelService) {

    const globalPanel: HTMLElement = this.$panel.getGlobalPanel();
    const allButtons: NodeListOf<HTMLLinkElement> = this.$panel.getAllPanelButtons();

    if (globalPanel && allButtons) {
      this.panelButtonEvent(globalPanel, allButtons);
    }
  }

  /**
   * Adds all the event listeners needed for the panel
   * @param panel the panel html element
   * @param buttons a list of buttons on the site
   */
  private panelButtonEvent(panel: HTMLElement, buttons: NodeListOf<HTMLLinkElement>): void {
    buttons.forEach(button => {
      button.addEventListener('click', async event => {
        event.preventDefault();
        const urlToLoad: string = button.href;
        const headline: string = button.innerHTML;

        if (await this.$panel.setContentToPanel(headline, urlToLoad)) {
          document.dispatchEvent(new Event('globalPanel:open'));
        }

      });
    });

    const panelCloseButton: HTMLElement = panel.querySelector('.js-global-panel-close');

    panelCloseButton?.addEventListener('click', event => {
      event.preventDefault();
      document.dispatchEvent(new Event('globalPanel:close'));
    })
  }
}
